import { createContext } from 'react';

const SearchContext = createContext(void 0);

SearchContext.displayName = 'context(Search)';

export default SearchContext;